import Skeleton from '@mui/material/Skeleton';
import Paper from '@mui/material/Paper';

export const MuiSkeletonVehicleTile = () => (
    <Paper className="carousel-slide-item">
        <Skeleton
            sx={{
                width: '100%',
                flex: '1 0 0',
                borderRadius: '16px 16px 0 0',
                py: '150px',
                mb: '-110px',
                transformOrigin: '0 0%',
            }}
        />
        <Skeleton sx={{ mx: 2 }} />
        <Skeleton sx={{ mx: 2 }} />
        <Skeleton sx={{ mx: 2, width: 160 }} />
    </Paper>
);
